import { PBox } from "../theme/BaseTheme";
import { FeatureImageLeft } from "../sections/FeatureImageLeft";
import { FeatureImageRight } from "../sections/FeatureImageRight";
import { SellFaq } from "../sections/SellFaq";
import UseCases from "../sections/UseCases";

const text_poster_generator_faq_data = [
    {
        question: "What is the Text Poster Generator, and how does it work?",
        answer: "The Text Poster Generator is a creative AI tool that turns your written prompts into stunning typographic art. Instead of using photos, you describe the scene, mood, and style — and the AI builds a detailed illustration entirely from words and shapes.",
    },
    {
        question: "Do I need any design or typography skills?",
        answer: "No design skills required! It's made for everyone — whether you're a beginner or a creative professional. Just type your idea, and let the generator transform your concept into artistic word-based visuals.",
    },
    {
        question: "What type of prompts work best?",
        answer: "Simple scene descriptions, creative concepts, quotes, characters, nature scenes, cityscapes, abstract visual ideas, and storytelling prompts work wonderfully. The more vivid and imaginative your prompt, the more unique your text poster will look.",
    },
];

const text_poster_generator_use_cases = [
    {
        title: "Social Media Content",
        description:
            "Generate eye-catching typographic posters for Instagram, TikTok, Pinterest, and beyond. Turn simple prompts into scroll-stopping visuals that inspire likes, shares, and followers.",
        image: "/images/text-poster/text-poster-5.webp",
    },
    {
        title: "Creative Posters & Prints",
        description:
            "Create custom art for rooms, studios, cafés, or offices using only your imagination and words. Perfect for wall décor, personal gifts, or meaningful quote artwork.",
        image: "/images/text-poster/text-poster-6.webp",
    },
    {
        title: "Branding & Storytelling",
        description:
            "Build conceptual visuals for campaigns, mood boards, product stories, and marketing themes. Use words to shape emotion, identity, and visual energy — all from a simple prompt.",
        image: "/images/text-poster/text-poster-7.webp",
    },
];

const TextPosterLanding = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/text-poster/text-poster-1.webp"}
                title={"Turn Any Idea into Word-Based Artwork"}
                description={
                    "Describe your vision — a café scene, nature landscape, portrait, or even an abstract mood — and watch it transform into poetic typographic illustration. Every curve and contour is crafted from letters and words, turning imagination into art."
                }
            />
            <FeatureImageRight
                image={"/images/text-poster/text-poster-2.webp"}
                title={"Create Unique Character & Scene Posters"}
                description={
                    "Type a prompt like 'a couple talking at a cozy café' or 'a surfer riding a sunset wave' — and the AI builds the scene entirely with expressive lettering. Perfect for storytelling, creative projects, and artistic exploration."
                }
            />
            <FeatureImageLeft
                image={"/images/text-poster/text-poster-3.webp"}
                title={"Bring Places & Memories to Life with Words"}
                description={
                    "Whether it's a Paris street, mountain sunrise, or tropical beach vibe, you can turn any memory or travel idea into stunning text-based art. Perfect for travel journals, décor, or mood-inspired posters."
                }
            />
            <FeatureImageRight
                image={"/images/text-poster/text-poster-4.webp"}
                title={"Design Motivational & Quote Posters"}
                description={
                    "Bring your words, affirmations, lyrics, poems, or slogans to life through dynamic typography. Ideal for daily inspiration, offices, bedrooms, and creative studios — elevate your message visually."
                }
            />
            <UseCases
                data={text_poster_generator_use_cases}
                title={"Turn Prompts Into Art With Text-Based Creativity"}
            />
            <SellFaq data={text_poster_generator_faq_data} />
        </PBox>
    );
};

export default TextPosterLanding;
